import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: "crew-list-mapping",
    template: require('./list-mapping.component.html')
})
export class ListMapping {

    constructor() {
        // default values
        this.isReadonly = false;
        this.title = "";
        this.childTitle = "";

        this.relationKey = "Id";
        this.relationName = "Name";
    }

    @Output()
    onAddRelation = new EventEmitter();

    addRelation() {
        this.onAddRelation.emit();
    }

    @Output()
    onRemoveRelation = new EventEmitter();

    removeRelation(relation) {
        this.onRemoveRelation.emit(relation);
    }

    @Input()
    parentEntity: any;

    @Input()
    relationCollectionName: string;

    @Input()
    allRelations: any[];

    @Input()
    relationEntityType: string;

    @Input()
    mappingIcon: string;

    @Input()
    isReadonly: boolean;

    @Input()
    title: string;

    @Input()
    childTitle: string;

    @Input()
    mappingKey: string;

    @Input()
    relationKey: string;

    @Input()
    relationName: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/list-mapping.component.ts